import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from 'seagull/components/Typography';
import pluralize from '~/utils/pluralize';
const UnbilledTimeActivities = (param)=>{
    let { serviceTimeActivitiesLength } = param;
    return /*#__PURE__*/ _jsx(Typography, {
        testId: "unbilled-time-activities",
        variant: "paragraph2",
        skin: "success",
        children: "".concat(pluralize('unbilled activity', serviceTimeActivitiesLength, true))
    });
};
export default UnbilledTimeActivities;
